import { createFileRoute } from "@tanstack/react-router";

import { FeatureFlagsPage } from "@/features/feature-flags/components/feature-flags-page";

export const Route = createFileRoute("/_authed/_dashboard/admin-tools/feature-flags")({
  component: FeatureFlagsPage,
});
